import { Notify } from "quasar";

function notify(message: string, success = true) {
  return Notify.create({
    message,
    color: success ? "positive" : "negative",
    position: "top",
    timeout: 5000,
    icon: success ? "check" : "warning",
  });
}

export function notifySuccess(message: string) {
  return notify(message, true);
}

export function notifyError(message: string) {
  return notify(message, false);
}
